<template>
  <DirectoryItemTable
    :key="itemType"
    ref="itemTable"
    :inDetailsAsidePanel="false"
    :isAsideOpen="isAsideOpen"
    :itemType="itemType"
    :panelType="mainPanel"
    :selectedModelId="selectedModelId"
    :setGettingStartedTooltipVisibility="showTooltip"
    :setSelectedModelId="setSelectedModelId"
    :viewport="viewport"
  />
</template>
<script>
import { ItemTableConsts } from 'client/util/Constants';
import DirectoryItemTable from 'client/directories/components/DirectoryItemTable.vue';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';

export default {
  name: 'DirectoriesMainPanel',

  components: {
    DirectoryItemTable,
  },

  mixins: [MainPanelMixin],

  data() {
    return {
      mainPanel: ItemTableConsts.panelType.mainPanel,
    };
  },
};
</script>
